import type { RunDescriptor } from '../contracts/game'
import type { GameplayTuning } from '../simulation/GameplayTuning'
import { Simulation } from '../simulation/Simulation'
import { ProceduralWorld } from '../world/ProceduralWorld'

export interface RunInstance {
  readonly simulation: Simulation
  readonly world: ProceduralWorld
}

export interface RunFactory {
  create(descriptor: RunDescriptor): RunInstance
}

export function createDefaultRunFactory(tuning: GameplayTuning): RunFactory {
  return {
    create(descriptor) {
      const world = new ProceduralWorld()
      const simulation = new Simulation(tuning, world)
      simulation.start(descriptor)
      return { simulation, world }
    },
  }
}
